/**
 * §P.1 + §P.12 · El marco de «Alumnos».
 *
 * ## Por qué las reservas de prueba viven aquí y no en «El club»
 *
 * Una reserva de clase de prueba **es un alumno que todavía no existe**: la acción
 * que la cierra es darlo de alta, y desde esa misma pantalla se enlaza con su ficha.
 * Ponerla junto a la ficha del buscador —que es la otra mitad de §P.12— habría
 * agrupado por de dónde sale el dato en vez de por qué se hace con él, y la habría
 * enterrado en una sección de ajustes que se abre dos veces al año.
 *
 * Es la lección que `secciones.ts` ya tenía escrita con `consents/missing`: una lista
 * accionable a tres clics dentro de ajustes es una lista que no se usa nunca. Y esta
 * tiene reloj: a los tres días la familia está apuntada en otro sitio.
 *
 * ## La ficha del alumno no lleva pestañas
 *
 * `/alumnos/$alumnoId` cuelga del panel y no de este marco, a propósito: una ficha
 * abierta es una pantalla entera, y una barra de pestañas encima invitaría a salir de
 * ella justo cuando se ha entrado a hacer algo.
 *
 * Sin guardián de rol: las dos rutas de debajo son `own`, `adm` y `coa`. El
 * entrenador ve las reservas porque en un club pequeño es quien coge el teléfono.
 */
import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { VISTAS_DE_ALUMNOS } from '@/club/secciones';

export function MarcoDeAlumnos() {
  const camino = useRouterState({ select: (s) => s.location.pathname });

  return (
    <>
      <nav className="pestañas" aria-label="Pantallas de alumnos">
        {VISTAS_DE_ALUMNOS.map((v) => {
          /*
           * La lista vive en `/alumnos` a secas y no en `/alumnos/lista`: es la
           * dirección que ya se ha compartido y la que devuelve media aplicación al
           * cerrar una ficha. Una pestaña no vale un enlace roto.
           */
          const destino = v.id === '' ? '/alumnos' : `/alumnos/${v.id}`;
          const activa =
            v.id === '' ? camino === '/alumnos' : camino.startsWith(destino);

          return (
            <Link
              key={v.id}
              to={destino}
              className={activa ? 'pestaña-activa' : 'btn-plano'}
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
